import {
  generateJsonLdForCollectionPage
} from '@helpers/products/json-ld/json-ld-collection-page.mjs';

export const GenerateCollectionPageDynamicSlugJsonLd = ({products}) => {
  // console.log('[GenerateCollectionPageDynamicSlugJsonLd] products:', products);
  if (!products?.length) return;
  const jsonLd = generateJsonLdForCollectionPage(products);
  // console.log('[GenerateCollectionPageDynamicSlugJsonLd] jsonLd:', jsonLd);

  return <script type="application/ld+json"
                 dangerouslySetInnerHTML={{__html: JSON.stringify(jsonLd)}}
  />;
};
